import React from "react";
import { useLanguage } from "../context/LanguageContext";
import { useModal } from "../context/ModalContext";
import { servicesData } from "../data/languageData";
import { servicesList } from "../data/servicesData";

const Services = () => {
  const { translate } = useLanguage();
  const { openModal } = useModal();

  const handleServiceClick = (serviceId) => {
    openModal("service", servicesData[serviceId]);
  };

  return (
    <section className="services" id="services">
      <div className="container">
        <div className="section-title">
          <h2>{translate("services-title")}</h2>
          <p>{translate("services-desc")}</p>
        </div>

        <div className="services-grid">
          {servicesList.map((service) => (
            <div
              className="service-card"
              key={service.id}
              data-service={service.id}
              onClick={() => handleServiceClick(service.id)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  handleServiceClick(service.id);
                }
              }}
            >
              <div className="service-icon">
                <i className={service.icon}></i>
              </div>
              <h3>{translate(service.titleKey)}</h3>
              <p>{translate(service.descKey)}</p>
              <button
                className="service-link"
                onClick={(e) => {
                  e.stopPropagation();
                  handleServiceClick(service.id);
                }}
                style={{
                  background: "none",
                  border: "none",
                  padding: 0,
                  cursor: "pointer",
                  color: "var(--primary-blue)",
                  fontWeight: "600",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  fontSize: "0.95rem",
                  textDecoration: "none",
                }}
              >
                <span>{translate("view-details")}</span>{" "}
                <i className="fas fa-arrow-right"></i>
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
